exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#query[data-v-68e18873] {\n  height: 2.25rem;\n  font-size: 1rem;\n}\n#query[data-v-68e18873]:focus {\n  background-color: #fff;\n  color: #000;\n  border-color: #b3c2c4;\n  box-shadow: 0 0 0 0.1rem #799498;\n}\n#submit-query[data-v-68e18873] {\n  height: 2.25rem;\n  height: 2.25rem;\n  font-size: 0.875rem;\n  background-color: #b3c2c4;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n}\n#submit-query[data-v-68e18873]:focus {\n  background-color: #d0d9da;\n  border-color: #b3c2c4;\n  box-shadow: 0 0 0 0.1rem #799498;\n}\n#submit-query[data-v-68e18873]:hover {\n  background-color: #fff;\n}", ""]);

// exports
